<template lang="html">
  <article class="categoria-home -backgroundLoad">
    <span
      class="background"
      :style="`background-image:url(${data.banner_image.url})`"
      v-if="!fake"
    ></span>

    <router-link
      class="hand-title enlace-cover row-center"
      :to="'/recetas/?' + data.slug"
      v-if="!fake"
    >
      <span v-if="!!data.name">{{ data.name }}</span>
    </router-link>
  </article>
</template>

<script lang="js">

import { mapGetters, mapActions } from "vuex";
  export default  {
    name: 'categoria-home',
    props: ['data','fake'],
    computed : {
      ...mapGetters(['getServer'])
    }
  }
</script>

<style scoped lang="scss">
.categoria-home {
  width: calc(33.3333333% - 20px);
  margin-right: 30px;
  margin-bottom: 30px;
  height: 270px;
  overflow: hidden;
  position: relative;
  /*opacity: 0;*/
  animation-fill-mode: both;
  -webkit-animation-iteration-count: 1;
  -o-animation-iteration-count: 1;
  animation-iteration-count: 1;
  animation-duration: 0.5s;
}

.categoria-home:nth-child(2) {
  animation-delay: 0.5s;
}
.categoria-home:nth-child(3) {
  animation-delay: 0.7s;
}
.categoria-home:nth-child(4) {
  animation-delay: 0.9s;
}
.categoria-home:nth-child(5) {
  animation-delay: 1.1s;
}
.categoria-home:nth-child(6) {
  animation-delay: 1.3s;
}

.active .categoria-home {
  /*animation-name: fadeInUp;*/
}

.categoria-home:nth-child(3n) {
  margin-right: 0;
}

.categoria-home .background {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  transition: 1s;
}

.categoria-home:hover .background {
  transform: scale(1.1);
}

.categoria-home .enlace-cover span {
  opacity: 0;
  transform: translateY(20px);
  transition: 0.3s transform, 0.5s opacity;
  transition-timing-function: ease-in-out;
  background: #ffffffc7;
  padding: 6px 16px;
  box-shadow: 2px 2px 20px 2px #00000085;
}

.categoria-home:hover .enlace-cover span {
  transform: translateY(0px);
  opacity: 1;
}

@media screen and (max-height: 1024px) {
  .categoria-home .enlace-cover span {
    transform: translateY(0px);
    opacity: 1;
  }
}

@media screen and (max-width: 1024px) {
  .categoria-home .enlace-cover span {
    transform: translateY(0px);
    opacity: 1;
  }
}

@media screen and (max-width: 1023px) {
  .categoria-home {
    width: calc(50% - 10px);
    margin: 0 0px 20px 0;
  }

  .categoria-home:nth-child(2n) {
    margin-right: 0;
  }

  .categoria-home:nth-child(3n) {
    margin-right: 0px;
  }
}

@media screen and (max-width: 720px) {
  .categoria-home {
    width: 100%;
    margin-right: 0;
  }

  .categoria-home:nth-child(2n) {
    margin-right: 0;
  }

  .categoria-home:nth-child(3n) {
    margin-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/categoria-home.vue